import { useState, useEffect } from 'react';
import axios from 'axios';
import Main from '../../../component/Main.jsx';
import ShowDetailDataGrid from "../../../component/common/dataGrid/ShowDetailDataGrid.jsx"
import useModalStore from '../../../zustand/store/useModalStore.js';

import * as Icons from '../../../images/icons/icons_component.js';

const TrnThesis = () => {

    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = String(today.getMonth() + 1).padStart(2, '0');
    const currentDay = String(today.getDate()).padStart(2, '0');

    const [nameList, setNameList] = useState([]);

    const [searchParams, setSearchParams] = useState({
        searchYear: currentYear,
        searchTrnNm: '',
        searchMonth: currentMonth,
        searchEmog: '',
    });

    const searchParamsAdditional = {};

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = ['상세보기', '필수사항 수행률', '권장사항 수행률'];
    const dataColumn = ['DETAIL_SN', 'ESSE_PER', 'RCMM_PER'];
    const apiCall = '/trmsapi/trnlst/trnNoteSearch.do';
    const apiCntCall = '';
    const excelFileName = '수련노트';
    const excelHead = ['순번', '필수사항 수행률', '권장사항 수행률'];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50,
        totalItems: 0
    });

    const popupPropsInfo = {
        checked: ["DETAIL"],
        localStorageName: "trnNoteData",
        popupAddress: "/nedis/trmsInfo/trms_trnNote_popup.do",
        height: '900'
    }

    if (searchParamsAdditional != null) {
        searchParamsAdditional.pageNum = parseInt(pageInfo.currentPage);
        searchParamsAdditional.displayRowsize = parseInt(pageInfo.itemsPerPage);
    }

    const totalObj = Object.assign({}, searchParams, searchParamsAdditional);

    // toast modal open function
    const showNotiModal = useModalStore(state => state.showNotiModal);

    const fetchData = async () => {
        try {
            delete totalObj.validationCheckList;
            const response = await axios.get(apiCall,
                { params: totalObj }
            );
            setState(prev => ({
                ...prev,
                dataList: response.data,
                isSearched: true
            }));
            if (apiCntCall === '') {
                setPageInfo(prev => ({
                    ...prev,
                    totalItems: response.data.length
                }));
            } else {
                fetchDataCnt();
            }
            setState(prev => ({
                ...prev,
                isLoading: false
            }));
        } catch (error) {
            console.error('데이터 로딩 중 오류 발생:', error);
        }
    };

    const fetchDataCnt = async () => {
        try {
            const response = await axios.get(apiCntCall,
                { params: totalObj }
            );
            setPageInfo(prev => ({
                ...prev,
                totalItems: response.data
            }));
        } catch (error) {
            console.error('데이터 카운터 중 오류 발생:', error);
        }
    };

    const fetchHospList = async () => {
        try {
            const response = await axios.get('/trmsapi/trnlst/searchTrnNm.do', {
                params: { searchEmog: searchParams.searchEmog }
            });
            setNameList(response.data || []);
        } catch (error) {
            console.error('병원 목록 로딩 중 오류 발생:', error);
        }
    };

    useEffect(() => {
        if (state.isSearched) {
            setState(prev => ({
                ...prev,
                isLoading: true
            }));
            fetchData();
        }
    }, [pageInfo.currentPage]);

    const search = () => {
        if (!searchParams.searchEmog) {
            showNotiModal("먼저 기관을 선택해주세요!");
            return;
        }
        setState(prev => ({
            ...prev,
            isSearched: false,
            isLoading: true
        }));
        setPageInfo(prev => ({
            ...prev,
            currentPage: 1,
        }));
        fetchData();
    };

    const add = () => {
        if (searchParams.searchEmog === '' || searchParams.searchTrnNm === '') {
            showNotiModal(searchParams.searchEmog === '' ? "먼저 기관을 선택해주세요!" : "입력할 전문의를 선택해주세요!");
            return false;
        }
        let popup = null;
        if (searchParams.searchEmog && searchParams.searchTrnNm) {
            localStorage.setItem(popupPropsInfo.localStorageName, JSON.stringify(searchParams));
            popup = window.open(popupPropsInfo.popupAddress, "팝업", "scrollbars=1, resizable=0, width=1010, height=900, top=30, left=30");
        }
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newName, setNewName] = useState('');

    const openModal = () => {
        if (!searchParams.searchEmog) {
            showNotiModal("먼저 기관을 선택해주세요!");
            return;
        }
        setIsModalOpen(true);
    };
    const closeModal = () => setIsModalOpen(false);

    const handleAdd = async () => {
        if (!newName.trim()) {
            alert("전문의명을 입력하세요.");
            return;
        }
        try {
            const response = await axios.get('/trmsapi/trnlst/addTrnNoteUser.do', {
                params: {
                    layerEmogcode: searchParams.searchEmog,
                    layerNm: newName,
                    userId: localStorage.getItem("id"),
                }
            });
            if (!response.data.hasError) {
                alert(response.data.resultMessage);
                fetchHospList();
            } else {
                alert(response.data.resultMessage + ". 다시 시도해주세요.");
                return;
            }
        } catch (error) {
            console.error('전문의 추가 중 오류 발생:', error);
        }
    };

    const handleDelete = async (detailSn) => {
        const confirmed = window.confirm(`정말 삭제하시겠습니까?`);
        if (!confirmed) return;

        try {
            const response = await axios.get('/trmsapi/trnlst/deleteTrnNoteUser.do', {
                params: {
                    EMOGCODE: searchParams.searchEmog,
                    DETAIL_SN: detailSn,
                    userId: localStorage.getItem("id"),
                }
            });
            if (!response.data.hasError) {
                alert(response.data.resultMessage);
                fetchHospList();
            } else {
                alert(response.data.resultMessage + ". 다시 시도해주세요.");
            }
        } catch (error) {
            console.error('삭제 요청 중 오류 발생:', error);
            alert("삭제 중 오류가 발생했습니다.");
        }
    };

    useEffect(() => {
        fetchHospList();
    }, [searchParams.searchEmog]);

    useEffect(() => {
        if (searchParams.searchEmog && searchParams.searchTrnNm) {
            search();
        }
    }, [searchParams.searchYear, searchParams.searchMonth])

    const getNextMonthStr = (monthStr) => {
        let nextMonth = parseInt(monthStr, 10) + 1;
        if (nextMonth > 12) nextMonth = 1;
        return nextMonth < 10 ? "0" + nextMonth : "" + nextMonth;
    };

    const getNextYear = (yearStr) => {
        let nextYear = parseInt(yearStr);
        if (searchParams.searchMonth === '12') { nextYear += 1; }
        return nextYear;
    }

    // esc 키 누르면 모달 닫히는 기능
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === "Escape") closeModal();
        };

        // 이벤트 리스너 등록
        document.addEventListener("keydown", handleEscape);

        // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
        return () => {
            document.removeEventListener("keydown", handleEscape);
        };
    }, [closeModal]);

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="15%" />
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                        <col width="15%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>조회기간</th>
                            <td>
                                <div className='flex gap-1'>
                                    <select id="searchYear"
                                        name="searchYear"
                                        value={searchParams.searchYear}
                                        onChange={handleInputChange}
                                    >
                                        {Array.from({ length: 10 }, (_, i) => {
                                            const year = (currentYear - i).toString()
                                            return (
                                                <option key={year} value={year}>
                                                    {year}년
                                                </option>
                                            );
                                        })}
                                    </select>
                                    <select id="searchMonth"
                                        name="searchMonth"
                                        value={searchParams.searchMonth}
                                        onChange={handleInputChange}
                                    >
                                        {Array.from({ length: 12 }, (_, i) => {
                                            const month = (i + 1).toString().padStart(2, '0');
                                            return (
                                                <option key={month} value={month}>
                                                    {month}월
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </td>
                            <th>의료기관명<span className='co_red'>&nbsp;*</span></th>
                            <td>
                                <select
                                    name='searchEmog'
                                    className='w-full'
                                    value={searchParams.searchEmog}
                                    onChange={handleInputChange}
                                >
                                    <option value="">선택</option>
                                    <option value="A1100014">고려대학교의과대학부속구로병원</option>
                                    <option value="A1400001">의료법인 길의료재단 길병원</option>
                                    <option value="A2100040">가톨릭대학교의정부성모병원</option>
                                    <option value="A2200001">연세대학교원주세브란스기독병원</option>
                                    <option value="A2900001">제주한라병원</option>
                                    <option value="A2100002">아주대학교병원</option>
                                </select>
                            </td>
                            <th>전문의명</th>
                            <td>
                                <select
                                    name='searchTrnNm'
                                    className='w-full'
                                    value={searchParams.searchTrnNm}
                                    onChange={handleInputChange}
                                >
                                    <option value="">전체</option>
                                    {nameList.map(name => (
                                        <option key={name.DETAIL_SN} value={name.DETAIL_SN}>
                                            {name.NM}
                                        </option>
                                    ))}
                                </select>
                            </td>
                            <td>
                                <button onClick={openModal} className='search_btn bg_tr_primary'><Icons.AddCircle16w />전문의 추가</button>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={7}>
                                <h5 className='bg-yellow co_dark w-fit px-2'>** {searchParams.searchYear}년 {searchParams.searchMonth}월 등록 가능 기간 : {searchParams.searchYear}-{searchParams.searchMonth}-11 ~ {getNextYear(searchParams.searchYear)}-{getNextMonthStr(searchParams.searchMonth)}-10 까지</h5>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='search_btn_wrapper'>
                <span className='total_items'>전체&nbsp;<strong className='tr_primary'>{pageInfo.totalItems}</strong>건</span>
                <div className='btn_container'>
                    <button onClick={search} disabled={state.isLoading ? 'disabled' : ''} className='search_btn bg_tr_primary'><Icons.Search16w />조회</button>
                    {(currentYear.toString() + currentMonth.toString() + currentDay.toString()) >= (searchParams.searchYear.toString() + searchParams.searchMonth.toString() + '11') && (currentYear.toString() + currentMonth.toString() + currentDay.toString()) <= (getNextYear(searchParams.searchYear) + getNextMonthStr(searchParams.searchMonth) + '10') ?
                        <button onClick={add} disabled={state.isLoading ? 'disabled' : ''} className='search_btn bg_co_black'><Icons.AddCircle16w />입력</button> : ''}
                </div>
            </div>
            {isModalOpen && (
                <div className='modal_container'>
                    <div className='confirm_wrapper'>
                        <div className='modal_title_box border-b pb-3'>
                            <h4>전문의 추가</h4>
                        </div>
                        <div className='w-full flex gap-3 items-center'>
                            <strong>전문의명</strong>
                            <input
                                type='text'
                                className='flex-1 input_style'
                                value={newName}
                                onChange={(e) => setNewName(e.target.value)}
                            />
                            <button onClick={handleAdd} className='search_btn bg_tr_primary'><Icons.AddCircle16w />추가</button>
                        </div>
                        <div className='w-full border-b co_border_gray'>
                            <table className='w-full border-t-2 tr_border_primary'>
                                <thead>
                                    <tr className='border-b'>
                                        <th className='text-center p-2'></th>
                                        <th className='text-center p-2'>소속</th>
                                        <th className='text-center p-2'>전문의명</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {nameList.length > 0 ?
                                        nameList.map((name, idx) => {
                                            const gridColor = idx % 2 === 0 ? 'bg_tr_odd' : '';
                                            return (
                                                <tr key={name.DETAIL_SN} className={`border-t ${gridColor}`}>
                                                    <td className='p-2'>
                                                        <button onClick={() => handleDelete(name.DETAIL_SN, name.EMOGDESC)} className='search_btn bg_co_red'><Icons.DeleteCircle16w />삭제</button>
                                                    </td>
                                                    <td className='text-center p-2'>{name.EMOGDESC}</td>
                                                    <td className='text-center p-2'>{name.NM}</td>
                                                </tr>
                                            )
                                        })
                                        :
                                        <tr>
                                            <td colSpan={1000} className='empty_box'>
                                                <span className='data_empty bg_tr_odd'>
                                                    등록된 전문의가 없습니다. 전문의를 추가해주세요.
                                                </span>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <hr className='w-full border-t' />
                        <div className='modal_btn w-full bg_co_black cursor-pointer' onClick={closeModal}>닫기</div>
                    </div>
                </div>
            )}
            <ShowDetailDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                searchParams={searchParams}
                popupPropsInfo={popupPropsInfo}
            />
        </Main >
    )
}

export default TrnThesis;